import React from 'react';
import { useHistory } from 'react-router-dom';
import * as S from './styles';
import { CarrierAreaContact } from 'interfaces/carrier-area-contact';
import { useTranslation, usePermissions } from 'hooks';
import { translations } from './translations';

interface IGridCarrierAreaContactsProps {
  contacts: CarrierAreaContact[] | Record<string, any>[];
}

interface ICarrierAreaContactProps {
  contact: CarrierAreaContact | Record<string, any>;
}

const Item: React.FC<ICarrierAreaContactProps> = ({ contact }) => {
  const history = useHistory();
  const { checkUserPermission } = usePermissions();
  const havePermission = checkUserPermission('editCarriers');
  return (
    <S.ItemContainer
      onClick={() =>
        havePermission &&
        history.push(`/settings/carrier-contact/${contact.id}`)
      }
    >
      <S.ItemContent pointer={havePermission}>
        <S.ItemValue>{contact.id}</S.ItemValue>
        <S.ItemValue>{contact.name}</S.ItemValue>
        <S.ItemValue>{contact.carrier.trade_name}</S.ItemValue>
        <S.ItemValue>{contact.area.name}</S.ItemValue>
        <S.ItemValue>{contact.role}</S.ItemValue>
        <S.ItemValue>{contact.email}</S.ItemValue>
        <S.ItemValue>{contact.phone_number}</S.ItemValue>
        {havePermission && (
          <S.ButtonDetail>
            <S.IconDetail />
          </S.ButtonDetail>
        )}
      </S.ItemContent>
    </S.ItemContainer>
  );
};

export const GridCarrierAreaContacts: React.FC<
  IGridCarrierAreaContactsProps
> = ({ contacts = [] }) => {
  const { getTranslation } = useTranslation(translations);

  return (
    <S.Container>
      <S.Header>
        <S.Label>{getTranslation('codigo')}</S.Label>
        <S.Label>{getTranslation('nome')}</S.Label>
        <S.Label>{getTranslation('transportadora')}</S.Label>
        <S.Label>{getTranslation('area')}</S.Label>
        <S.Label>{getTranslation('funcao')}</S.Label>
        <S.Label>{getTranslation('email')}</S.Label>
        <S.Label>{getTranslation('telefone')}</S.Label>
      </S.Header>
      {contacts.length > 0 &&
        contacts.map((contact) => <Item contact={contact} key={contact.id} />)}
    </S.Container>
  );
};
